import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { OLAF, GREAT_WHITE } from 'HubStyleTokens/colors';
import UIImage from 'UIComponents/image/UIImage';
import H2 from 'UIComponents/elements/headings/H2'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import { useAppSelector } from '../../../../reducers';
import { suiteProductConfigurationsSelector } from '../../../../selectors/ProductConfigsSelectors';
import { HighlightedProductsHeaderConfig } from '../../../../constants/merchCards/HighlightedProductsHeaderConfig';
import { currentSkuIdForProductSelector } from '../../../../selectors/ProductsSelectors';
import IncludedUnitsSubtext from './IncludedUnitsSubtext';
const TopHeaderCell = styled.th.withConfig({
  displayName: "MobileSuiteCatalogEditionHeader__TopHeaderCell",
  componentId: "ziax1i-0"
})(["padding:12px 20px;background-color:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";height:50px;text-align:center;width:18.75%;min-width:175px;font-weight:500;& > h6{margin:0;}:first-child{width:25%;text-align:left;}h2{font-size:20px;}.crm-suite-bold{font-weight:600;}"], OLAF, GREAT_WHITE, GREAT_WHITE);
const Table = styled.table.withConfig({
  displayName: "MobileSuiteCatalogEditionHeader__Table",
  componentId: "ziax1i-1"
})(["border-spacing:0;width:100%;margin-bottom:0;"]);

const MobileSuiteCatalogEditionHeader = ({
  productLine,
  productLevel,
  queryParamTerm
}) => {
  const skuId = useAppSelector(state => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));
  const {
    includes
  } = HighlightedProductsHeaderConfig[productLine][productLevel];
  const productConfigurations = useAppSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  return /*#__PURE__*/_jsx(Table, {
    children: /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx(TopHeaderCell, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              float: 'left'
            },
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(UIImage, {
                className: "display-inline m-right-2 m-bottom-2",
                width: 15,
                src: ProductLinePageIcons[productLine]
              }), /*#__PURE__*/_jsx(H2, {
                className: "display-inline",
                "aria-level": 3,
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: `pricingPage.pages.suite.catalogModal.${productLine.toLowerCase()}.${productLevel.toLowerCase()}`
                })
              })]
            }), includes && /*#__PURE__*/_jsx(IncludedUnitsSubtext, {
              skuId: skuId,
              className: "m-left-6",
              style: {
                fontWeight: 400
              },
              queryParamTerm: queryParamTerm,
              productConfigurations: productConfigurations
            })]
          })
        })
      })
    })
  });
};

export default MobileSuiteCatalogEditionHeader;